function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import { Accordion as ChakraAccordion, AccordionItem as ChakraAccordionItem, AccordionButton, AccordionPanel } from "@chakra-ui/react";
import { Box } from "@thebouqs/layout";
import { AddIcon } from "@thebouqs/icons";

var AccordionItemHeading = _ref => {
  var {
    title,
    tag = "h2"
  } = _ref,
      styleProps = _objectWithoutPropertiesLoose(_ref, ["title", "tag"]);

  var colorProps = {
    color: "black"
  };
  return /*#__PURE__*/React.createElement(Box, {
    as: tag
  }, /*#__PURE__*/React.createElement(AccordionButton, {
    backgroundColor: "white",
    border: "none",
    color: "black",
    sx: _extends({}, styleProps, colorProps)
  }, /*#__PURE__*/React.createElement(Box, {
    textAlign: "left",
    fontWeight: "600",
    fontSize: "lg",
    minWidth: 16,
    minHeight: 4
  }, title), /*#__PURE__*/React.createElement(AddIcon, {
    marginLeft: 2,
    fontSize: "sm"
  })));
};

var AccordionItem = _ref2 => {
  var {
    children
  } = _ref2,
      styleProps = _objectWithoutPropertiesLoose(_ref2, ["children"]);

  var accordionItemStyleProps = _extends({
    borderBottomWidth: "1px",
    borderBottomColor: "gray.100",
    borderBottomStyle: "solid",
    p: "6"
  }, styleProps);

  return /*#__PURE__*/React.createElement(ChakraAccordionItem, accordionItemStyleProps, children);
};

var AccordionItemPanel = _ref3 => {
  var {
    hasHtml,
    bodyText
  } = _ref3;
  return /*#__PURE__*/React.createElement(AccordionPanel, {
    py: 4,
    px: 1
  }, hasHtml ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: bodyText
    }
  }) : bodyText);
};

var Accordion = _ref4 => {
  var {
    allowMultiple = true,
    children,
    allowToggle = false,
    defaultIndex = 0
  } = _ref4;
  return /*#__PURE__*/React.createElement(ChakraAccordion, {
    defaultIndex: [defaultIndex],
    allowMultiple: allowMultiple,
    allowToggle: allowToggle
  }, children);
};

export { AccordionItem, AccordionPanel, AccordionItemHeading, AccordionItemPanel, Accordion };
//# sourceMappingURL=Accordion.js.map